'use strict';

var React = require('react');

var SvgTickSmallMinor = function SvgTickSmallMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.03 7.22a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.72 3.97-3.97a.75.75 0 0 1 1.06 0Z"
  }));
};
SvgTickSmallMinor.displayName = "TickSmallMinor";

exports.SvgTickSmallMinor = SvgTickSmallMinor;
